import { ButtonBase } from ".";
import { ACTION_STATUS } from "..";

export class ExportButtonModel extends ButtonBase {
    label: string = 'Export';
    action: string = ACTION_STATUS.export;
    matIconName: string = 'ios_share';
    colorClass: string = 'color-tertiary-500';
}